import { useState, useCallback, useRef } from 'react';
import { productApi } from '../api';

const formatError = (err) => {
  const data = err.data;
  if (data?.message && data?.code) {
    return { code: data.code, message: data.message };
  }
  return { code: null, message: err.message || 'Đã xảy ra lỗi' };
};

export default function useProducts() {
  const [resources, setResources] = useState(null);
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ page: 1, size: 20, type: [], sort: null, sortOrder: null, search: '' });
  const resourcesLoadedRef = useRef(false);

  const loadResources = useCallback(async () => {
    if (resourcesLoadedRef.current) return;
    resourcesLoadedRef.current = true;
    try {
      const res = await productApi.getResources();
      setResources(res.data);
    } catch (err) {
      setError(formatError(err));
    }
  }, []);

  const loadProducts = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const res = await productApi.getProducts(params || filters);
      setProducts(res.data);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const getProductDetail = useCallback(async (productId) => {
    setLoadingDetail(true);
    setError(null);
    try {
      const res = await productApi.getProductDetail(productId);
      return res.data;
    } catch (err) {
      setError(formatError(err));
      return null;
    } finally {
      setLoadingDetail(false);
    }
  }, []);

  const openBuyWebview = useCallback(async (productId) => {
    try {
      const res = await productApi.getBuyWebview(productId);
      if (res.data?.webviewUrl) {
        window.open(res.data.webviewUrl, '_blank', 'noopener,noreferrer');
      }
      return { success: true, data: res.data };
    } catch (err) {
      return { success: false, error: formatError(err) };
    }
  }, []);

  const updateFilters = useCallback((newFilters) => {
    setFilters((prev) => {
      const updated = { ...prev, ...newFilters };
      if (newFilters.type !== undefined || newFilters.search !== undefined || newFilters.sort !== undefined) {
        updated.page = 1;
      }
      return updated;
    });
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    resources,
    products,
    loading,
    loadingDetail,
    error,
    filters,
    loadResources,
    loadProducts,
    getProductDetail,
    openBuyWebview,
    updateFilters,
    clearError,
  };
}
